import useIsPermittedTo from "PFCore/helpers/use_is_permitted_to";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { PermissionRule } from "PFTypes";
import { useMemo } from "react";

import { useTemplate } from "./hooks";

export const useIsWorkflowPermitted = () => {
  const { data: currentProfile } = useCurrentProfile();
  const isPermittedTo = useIsPermittedTo(currentProfile);
  const engagementTemplate = useTemplate("engagement");
  const roleTemplate = useTemplate("role");

  const workflowAccess = useMemo(() => {
    const engagementReadPermitted = engagementTemplate?.read_permitted;
    const roleReadPermitted = roleTemplate?.read_permitted;
    const isResourcer = isPermittedTo(PermissionRule.Resourcer);
    const isSeniorPartner = isPermittedTo(PermissionRule.SeniorPartner);
    return (engagementReadPermitted || roleReadPermitted) && (isResourcer || isSeniorPartner);
  }, [isPermittedTo, engagementTemplate?.read_permitted, roleTemplate?.read_permitted]);

  return workflowAccess;
};

export default useIsWorkflowPermitted;
